import React from 'react'
import Header from '../headerone/Main'
import Bredcom from '../Bredcom/Main'
import { Link } from 'react-router-dom'
import NewMain from '../headerone/newMain'
import NewIqacSidebar from './NewIqacSidebar'

function NIRFRankingStatus1() {
  return (
    <>
    <style>{` .footer_main01  { display:none;      } `}</style>
      <div className='new_iqac'>
         
              <div className='row'>
                  <div className='col-md-3'>
                         <NewIqacSidebar />
                  </div>

                  <div className='col-md-9'>
                    <div className='home'>
                        <div className='about'>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='text'>
                                        <h3>NIRF Ranking Status – MVN University
                                        </h3>
                                        <p>The MVN University in the process of securing a prestigious rank among the top institutions in India under the National Institutional Ranking Framework (NIRF), released by the Ministry of Education, Government of India.
                                        </p>
                                        <p>In the NIRF Rankings, MVN University continuously participated, reflecting our commitment to academic excellence, cutting-edge research, and holistic development.
                                        </p>
                                        <p>Our continuous efforts in securing ranking reflect the university’s dedication to quality education, impactful research, and strong industry and societal engagement.
                                        </p>
                                        <p>We thank our faculty, students, staff, and stakeholders for their continued efforts in elevating the university’s national standing.
                                        </p>
                                        <p>For more details on the NIRF, please visit the official <b>website: https://www.nirfindia.org</b>
                                        </p>
                                    </div>
                                    <br></br>
                                    <div className='ranking'>
                                      <div className='img'>
                                        <img src='/assets/img/ranking.png'></img>
                                      </div>
                                      <div className='table'>
                                        <table className='table table-bordered table-responsive composition-table'>
                                          <thead>
                                            <tr>
                                              <th>NIRF Year</th>
                                              <th>Status</th>
                                              <th colSpan={2}>See Record (Click on PDF File to see Submitted Data)</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr>
                                              <td></td>
                                              <td></td>
                                              <td>University (Overall)</td>
                                                      <td>Pharmacy</td>
                                               
                                            </tr>

                                            <tr>
                                              <td>NIRF 2026</td>
                                              <td>Participated</td>
                                              <td><a href="/assets/img/pdf/nirf01.pdf" target="_blank"><img src='/assets/img/pdficon.png'></img></a></td>
                                              <td><a href="/assets/img/pdf/nirf02.pdf" target="_blank"><img src='/assets/img/pdficon.png'></img></a></td>
                                               
                                            </tr>


                                            <tr>
                                              <td>NIRF 2025</td>
                                              <td>Participated</td>
                                              <td><a href="/assets/img/pdf/nirf03.pdf" target="_blank"><img src='/assets/img/pdficon.png'></img></a></td>
                                              <td><a href="/assets/img/pdf/nirf04.pdf" target="_blank"><img src='/assets/img/pdficon.png'></img></a></td>
                                               
                                            </tr>

                                             <tr>
                                              <td>NIRF 2024</td>
                                              <td>Participated</td>
                                              <td><a href="/assets/img/pdf/nirf05.pdf" target="_blank"><img src='/assets/img/pdficon.png'></img></a></td>
                                              <td><a href="/assets/img/pdf/nirf06.pdf" target="_blank"><img src='/assets/img/pdficon.png'></img></a></td>
                                               
                                            </tr>

                                              <tr>
                                              <td>NIRF 2023</td>
                                              <td>Participated</td>
                                              <td><a href="/assets/img/pdf/nirf07.pdf" target="_blank"><img src='/assets/img/pdficon.png'></img></a></td>
                                              <td><a href="/assets/img/pdf/nirf08.pdf" target="_blank"><img src='/assets/img/pdficon.png'></img></a></td>
                                               
                                            </tr>






 
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                      
                    </div>
                  </div>


              </div>

         

      </div>

    </>
  )
}

export default NIRFRankingStatus1